import { forwardRef, useRef } from 'react';

function forwardRefWithHook(render) {
  const ForwardedComponent = forwardRef(
    render
  );
  ForwardedComponent.useForwardedRef = () => useRef(null);
  return ForwardedComponent;
}

export { forwardRefWithHook as default };
//# sourceMappingURL=index.mjs.map
